import { MessageSegmentType, StructuredHintMessage } from 'src/app/shared/types/structured-message';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';

export function buildStructuredMessage(
  id: string,
  segments: Array<[MessageSegmentType, string | CurrencyAmountDisplay]>,
): StructuredHintMessage {
  return {
    id,
    segments: segments.map(([type, value]) =>
      typeof value === 'string'
        ? { type, content: value }
        : { type, content: value.text, icon: value.icon, iconPosition: value.iconPosition },
    ),
  };
}
